<template>
  <div class="layout-header">
    <div class="layout-header-wrapper">
      <div class="layout-header-l">
        <a class="logo" href="/"
          ><svg-icon
            name="xd_logo_"
            width="115"
            height="30"
            style="margin: 0 20px 0 0"
          ></svg-icon
          ><svg-icon name="logo_text" style="width: 168px; height: 20px"></svg-icon
        ></a>
      </div>
      <div class="layout-header-c">
        <div class="menu">
          <ul>
            <li :class="currRouter.path === '/' ? 'checked' : ''">
              <a href="/">首页</a>
            </li>
            <li><a target="_blank" href="https://ppt.101dao.com/custom/">PPT定制</a></li>
            <li>
              <a target="_blank" href="https://jianli.101dao.com/custom/">简历定制</a>
            </li>
            <li>
              <a target="_blank" href="https://ppt.101dao.com/article/?f=design"
                >象刀学院</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="layout-header-r">
        <div class="search-warp"><searchBox /></div>
        <div class="product-box" style="display: none">
          <Dropdown
            :trigger="['hover']"
            overlayClassName="vipduct-dropdown"
            placement="bottomCenter"
          >
            <button class="vipduct-button">
              <svg-icon name="vip_logo" width="20px" height="19px"></svg-icon>
            </button>
            <template #overlay>
              <Menu>
                <div class="vipduct-content">
                  <h2>加入会员，即可享受</h2>
                  <ul>
                    <li>
                      <i
                        ><svg-icon name="vip_num" width="16px" height="16px"></svg-icon
                      ></i>
                      <div>
                        <h3>20万+原创精品模板</h3>
                        <p>海量平面、H5、视频、PPT模板免费使用</p>
                      </div>
                    </li>
                    <li>
                      <i
                        ><svg-icon name="vip_image" width="16px" height="16px"></svg-icon
                      ></i>
                      <div>
                        <h3>150万+正版素材</h3>
                        <p>图片、字体、音乐全类型覆盖</p>
                      </div>
                    </li>
                    <li>
                      <i
                        ><svg-icon name="vip_baoz" width="18px" height="18px"></svg-icon
                      ></i>
                      <div>
                        <h3>商用零风险</h3>
                        <p>提供商用授权书，保障商用无忧</p>
                      </div>
                    </li>
                    <li>
                      <i
                        ><svg-icon name="vip_gongn" width="16px" height="16px"></svg-icon
                      ></i>
                      <div>
                        <h3>高级功能特权</h3>
                        <p>专享PPT源格式下载，更多AI抠图等</p>
                      </div>
                    </li>
                  </ul>
                  <div class="vipduct-btns">
                    <Button type="base">了解更多</Button
                    ><Button type="primary">立即升级会员</Button>
                  </div>
                </div>
              </Menu>
            </template>
          </Dropdown>
        </div>
        <div class="product-box" style="display: none">
          <Dropdown
            :trigger="['hover']"
            overlayClassName="message-dropdown"
            placement="bottomCenter"
          >
            <button class="message-button">
              <svg-icon name="mess" width="22px" height="22px"></svg-icon
              ><span class="message-num">2</span>
            </button>
            <template #overlay>
              <Menu>
                <div class="message-content">
                  <Card
                    :tab-list="tabListNoTitle"
                    :active-tab-key="noTitleKey"
                    @tabChange="(key) => onTabChange(key, 'noTitleKey')"
                  >
                    <div class="message-body" v-if="noTitleKey === 'unread'">
                      <div class="message-item">
                        <ul>
                          <li>
                            <i></i>
                            <div class="message-info">
                              <h3>活动通知</h3>
                              <p class="content">
                                完成【使用模板作图】任务获得 6积分～
                                <a href="/">立即查看</a>
                              </p>
                              <p class="date">2021-08-17 21:53</p>
                            </div>
                          </li>
                          <li>
                            <i></i>
                            <div class="message-info">
                              <h3>活动通知</h3>
                              <p class="content">
                                完成【使用模板作图】任务获得 6积分～
                                <a href="/">立即查看</a>
                              </p>
                              <p class="date">2021-08-17 21:53</p>
                            </div>
                          </li>
                          <li>
                            <i></i>
                            <div class="message-info">
                              <h3>活动通知</h3>
                              <p class="content">
                                完成【使用模板作图】任务获得 6积分～
                                <a href="/">立即查看</a>
                              </p>
                              <p class="date">2021-08-17 21:53</p>
                            </div>
                          </li>
                          <li>
                            <i></i>
                            <div class="message-info">
                              <h3>活动通知</h3>
                              <p class="content">
                                完成【使用模板作图】任务获得 6积分～
                                <a href="/">立即查看</a>
                              </p>
                              <p class="date">2021-08-17 21:53</p>
                            </div>
                          </li>
                          <li>
                            <i></i>
                            <div class="message-info">
                              <h3>活动通知</h3>
                              <p class="content">
                                完成【使用模板作图】任务获得 6积分～
                                <a href="/">立即查看</a>
                              </p>
                              <p class="date">2021-08-17 21:53</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="message-body" v-else-if="noTitleKey === 'read'">
                      app content
                    </div>

                    <div class="message-footer">
                      <a>全部已读</a><a>查看全部<svg-icon name="arrow"></svg-icon></a>
                    </div>
                  </Card>
                </div>
              </Menu>
            </template>
          </Dropdown>
        </div>
        <div class="divider" style="display: none"></div>
        <div class="product-box">
          <Dropdown :trigger="['hover']" overlayClassName="product-dropdown">
            <button style="min-width: 86px">
              更多产品 <svg-icon name="arrow bottom" width="12px" height="8px"></svg-icon>
            </button>
            <template #overlay>
              <Menu>
                <div class="product-content">
                  <div class="product-item child-product">
                    <h1>子品牌站</h1>
                    <ul>
                      <li>
                        <a href="https://ppt.101dao.com/" target="_blank"
                          ><img src="../../../assets/images/user/ppt.png"
                        /></a>
                      </li>
                      <li>
                        <a href="https://jianli.101dao.com/" target="_blank"
                          ><img src="../../../assets/images/user/cv.png"
                        /></a>
                      </li>
                      <li>
                        <a href="https://sucai.101dao.com/" target="_blank"
                          ><img src="../../../assets/images/user/sucai.png"
                        /></a>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="product-item custom-servie">
                    <h1>其它服务</h1>
                    <ul>
                      <li><a href="https://ppt.101dao.com/custom/" target="_blank">
                      <svg 
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 width="29px" height="28px">
<path fill-rule="evenodd"  fill="rgb(0, 100, 250)"
 d="M27.000,2.000 L27.000,18.000 L27.000,20.000 L20.109,20.000 L24.993,25.495 L23.662,26.992 L17.447,20.000 L12.071,20.000 L12.243,20.172 L5.172,27.243 L3.757,25.828 L9.586,20.000 L4.000,20.000 L3.000,20.000 L2.000,20.000 L2.000,2.000 L-0.000,2.000 L-0.000,-0.000 L29.000,-0.000 L29.000,2.000 L27.000,2.000 ZM25.000,2.000 L4.000,2.000 L4.000,18.000 L25.000,18.000 L25.000,2.000 ZM10.000,16.000 L7.000,16.000 L7.000,9.000 L10.000,9.000 L10.000,16.000 ZM16.000,16.000 L13.000,16.000 L13.000,4.000 L16.000,4.000 L16.000,16.000 ZM22.000,16.000 L19.000,16.000 L19.000,9.000 L22.000,9.000 L22.000,16.000 Z"/>
</svg>PPT定制
                      </a></li>
                      <li style="display:none;"><a href="https://www.100chui.com/custom/" target="_blank">
                      <svg 
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 width="23px" height="27px">
<path fill-rule="evenodd"  fill="rgb(0, 100, 250)"
 d="M21.000,27.000 L2.000,27.000 C0.895,27.000 -0.000,26.105 -0.000,25.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 L21.000,-0.000 C22.105,-0.000 23.000,0.895 23.000,2.000 L23.000,25.000 C23.000,26.105 22.105,27.000 21.000,27.000 ZM21.000,2.000 L2.000,2.000 L2.000,25.000 L21.000,25.000 L21.000,2.000 ZM18.000,18.000 L5.000,18.000 L5.000,16.000 L18.000,16.000 L18.000,18.000 ZM18.000,22.000 L5.000,22.000 L5.000,20.000 L18.000,20.000 L18.000,22.000 ZM7.066,12.922 C7.066,12.922 7.000,12.651 7.000,12.512 C7.000,11.227 7.893,10.115 9.213,9.503 C9.078,9.196 9.000,8.857 9.000,8.500 C9.000,7.119 10.119,6.000 11.500,6.000 C12.881,6.000 14.000,7.119 14.000,8.500 C14.000,8.857 13.922,9.196 13.787,9.503 C15.106,10.115 16.000,11.227 16.000,12.512 C16.000,12.677 15.908,12.999 15.908,12.999 L7.066,12.922 Z"/>
</svg>简历定制
                      </a></li>
                    </ul>
                  </div> -->
                </div>
              </Menu>
            </template>
          </Dropdown>
        </div>
        <div v-if="!isLogin" class="avatar-box">
          <span class="avatar-icon" style="display: none"></span>
          <span class="avatar-text">
            <Button type="primary" @click="showLoginModal">注册登录</Button>
          </span>
        </div>
        <div v-else class="user-box">
          <Dropdown :trigger="['hover']" overlayClassName="user-dropdown">
            <a class="avatar-img" href="/set"><img :src="userInfo.avatar" /></a>
            <template #overlay>
              <Menu>
                <div class="user-content">
                  <div class="user-info">
                    <div class="user-info-text">
                      <p>{{ decodeURI(userInfo.user_nickname) }}</p>
                      <p>ID：{{ userInfo.userid }}</p>
                    </div>
                    <div class="user-info-btn" style="display: none">
                      <a href="/vip">升级VIP</a>
                    </div>
                  </div>
                  <div class="user-vip" style="display: none">
                    <i
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="rgb(255, 255, 255)"
                          d="M12.000,-0.000 C18.627,-0.000 24.000,5.373 24.000,12.000 C24.000,18.627 18.627,24.000 12.000,24.000 C5.372,24.000 -0.000,18.627 -0.000,12.000 C-0.000,5.373 5.372,-0.000 12.000,-0.000 ZM6.000,7.000 L6.000,9.053 L7.400,9.053 L7.400,20.000 L20.000,7.000 L15.800,7.000 L10.200,12.474 L10.200,7.000 L6.000,7.000 Z"
                        /></svg
                    ></i>
                    <div class="info">
                      <p><b>普通会员</b></p>
                      <p>到期时间：终身有效</p>
                    </div>
                  </div>
                  <div class="user-menu">
                    <ul>
                      <li><a href="/space">我的作品</a></li>
                      <li><a href="/collect">我的收藏</a></li>
                      <li><a href="/set">账户设置</a></li>
                      <li @click="onOutLogin"><a href="javascript:;">退出登录</a></li>
                    </ul>
                  </div>
                </div>
              </Menu>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import { MutationTypes, useStore } from "@/store";
import router from "@/router";
import searchBox from "@/components/searchBox.vue";
import { setCookie } from "@/utils/common";
import { UserService } from "@/api/user";
export default defineComponent({
  name: "Header",
  components: {
    searchBox,
  },
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const isLogin = computed(() => store.state.token);
    const search = computed(() => store.state.seachKey);
    const currRouter = ref(router.currentRoute.value);
    const noTitleKey = "unread";
    const key = "unread";
    const tabListNoTitle = [
      {
        key: "unread",
        tab: "未读",
      },
      {
        key: "read",
        tab: "全部",
      },
    ];
    const searchKey = reactive({
      keyValue: search.value,
    });
    const onTabChange = (key: any, type: string | number) => {
      this[type] = key;
    };
    const showLoginModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, true);
    };
    const onOutLogin = async () => {
      const res = await UserService.loginOut();
      if (res.data.state === 2) {
        // setCookie('userid', '',7)
        setCookie("tokens", "", -1);
        router.go(0);
      }
      // router.go(0)
    };
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    return {
      isLogin,
      noTitleKey,
      key,
      tabListNoTitle,
      onTabChange,
      userInfo,
      showLoginModal,
      ...toRefs(searchKey),
      onOutLogin,
      onSearch,
      currRouter,
    };
  },
});
</script>

<style lang="scss" scoped>
.layout-header {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  box-shadow: 0 4px 16px rgb(0 0 0 / 4%);
  background: #fff;
}
.layout-header-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  height: 56px;
  align-items: center;
  .layout-header-l {
    min-width: 338px;
  }
  .layout-header-c {
    width: 100%;
  }
  .layout-header-r {
    min-width: 500px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .menu {
    width: 100%;
    text-align: left;
    border-left: 1px solid #ced5e0;
    line-height: 24px;
    margin-left: 20px;
    ul {
      display: flex;
      li {
        padding: 0 20px;
        min-width: 90px;
        text-align: center;
        a {
          color: #52575f;
        }
      }
      a:hover {
        color: $themeColor;
      }
      .checked a {
        color: $themeColor;
        font-weight: bold;
      }
    }
  }
  .avatar-box {
    display: flex;
    align-items: center;
    .avatar-icon {
      display: inline-block;
      width: 42px;
      height: 42px;
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='46' height='46' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F3F4F7' cx='23' cy='23' r='23'/%3E%3Cpath d='M14 31.545c0-4.016 3.171-7.272 7.083-7.272h2.834c3.912 0 7.083 3.256 7.083 7.272 0 .703-.57 1.273-1.273 1.273H15.273c-.703 0-1.273-.57-1.273-1.273zm14.167-13.272c0 2.917-2.453 5.272-5.49 5.272-3.037 0-5.49-2.355-5.49-5.272 0-2.918 2.453-5.273 5.49-5.273 3.037 0 5.49 2.355 5.49 5.273z' fill='%23AAA'/%3E%3C/g%3E%3C/svg%3E");
      margin-right: 20px;
      background-size: cover;
      cursor: pointer;
    }
    .avatar-text {
      display: flex;
    }
    .avatar-text a {
      font-size: 14px;
      color: #333;
      width: 40px;
      text-align: center;
    }
    .avatar-text i {
      height: 18px;
      color: #333;
      font-style: normal;
    }
  }
  .user-box {
    .avatar-img {
      width: 40px;
      height: 40px;
      display: inline-block;
      border-radius: 40px;
      overflow: hidden;
      img {
        width: 100%;
        display: block;
      }
    }
  }
  .search-warp {
    position: relative;
    min-width: 360px;
    width: 100%;
    padding-right: 20px;
  }
  .product-box {
    margin: 0 10px;
    button {
      line-height: 38px;
      cursor: pointer;
    }
    button:hover {
      color: $themeColor;
    }
    .message-button {
      position: relative;
      .message-num {
        position: absolute;
        height: 16px;
        border-radius: 12px;
        background-color: #f54531;
        color: #fff;
        line-height: 15px;
        font-size: 12px;
        min-width: 16px;
        text-align: center;
        right: 0;
        top: 4px;
      }
    }
    .message-button:hover {
      color: $themeColor;
      .svg-icon {
        fill: $themeColor;
        color: $themeColor;
      }
    }
  }

  .divider {
    min-width: 1px;
    height: 24px;
    margin: 0 10px;
    background-color: #ced5e0;
  }
}
.dashboard-header {
  .search-warp {
    display: none;
  }
}
.dashboard-header.show {
  .search-warp {
    display: block;
  }
}
</style>
